export const ROLE_CONSTANTS = {
    CHANNEL: 'channel',
    CONTRACTOR: 'contractor',
    MDU: 'mdu'
};
